// extracted by css-extract-rspack-plugin
export default {"footer":"footer-xbHqKm text-body-sm"};